// Toggle Login Box

jQuery(document).ready(function ($) {

	var $menu = $('.c-login-box');

	$('.c-login-btn').on('click', function (e) {
		$(this).stop().toggleClass('active');
		const href = $('.c-login-btn').attr('href');
		if (($menu.has(e.target).length === 0 && (href.length === 0 || href === "#"))) {

			e.preventDefault();

			if (!$menu.hasClass('active')) {
				$menu.addClass('active');

				$(document).one('click', function closeTooltip(e) {

					if ($menu.has(e.target).length === 0 && $('.c-login-btn').has(e.target).length === 0) {
						$menu.removeClass('active');
						$('.c-login-btn').removeClass('active');
					} else if ($menu.hasClass('active')) {
						$(document).one('click', closeTooltip);
					}
				});
			} else {
				$menu.removeClass('active');
			}
		}
	});

});
